import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { Observable } from "rxjs";
import { AUTH_TYPE } from "../utils/enum";

@Injectable({
  providedIn: "root",
})
export class CommonApiservice {
  constructor(
    private httpClient: HttpClient,
    public router: Router,
  ) {}
  // signup api
  doSignUp(userDetails: any): Observable<any> {
    const request = {
      url: "register",
      params: userDetails,
    };
    return this.httpClient.post<any>(request.url, request.params);
  }

  // verifyotp
  verifyOtp(otpDetails: any): Observable<any> {
    const request = {
      url: "verifyOTP" + `?authType=${AUTH_TYPE.POST_AUTH}`,
      params: otpDetails,
    };
    return this.httpClient.post<any>(request.url, request.params);
  }

  // otp api
  sendotp(otpDetails: any): Observable<any> {
    const request = {
      url: "sendOTP" + `?authType=${AUTH_TYPE.POST_AUTH}`,
      params: otpDetails,
    };
    return this.httpClient.post<any>(request.url, request.params);
  }

  // verifyotp
  verifyLogin(loginDetails: any): Observable<any> {
    const request = {
      url: "login",
      params: loginDetails,
    };
    return this.httpClient.post<any>(request.url, request.params);
  }

  // forgot password API
  forgotPassword(forgotpass: any): Observable<any> {
    const request = {
      url: "forgotPassword",
      params: forgotpass,
    };
    return this.httpClient.post<any>(request.url, request.params);
  }
  // New password API
  newPassword(newPass: any): Observable<any> {
    const request = {
      url: "resetpassword",
      params: newPass,
    };
    return this.httpClient.put<any>(request.url, request.params);
  }

  // New password API
  refreshToken(token: any): Observable<any> {
    const request = {
      url: "refreshToken",
      params: token,
    };
    return this.httpClient.post<any>(request.url, request.params);
  }

  numberOnly(event: any): boolean {
    const charCode = event.which ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;
  }
  openInNewTab(route: any) {
    // Converts the route into a string that can be used
    // with the window.open() function
    const url = this.router.serializeUrl(
      this.router.createUrlTree([`/custompage/${route.id}`]),
    );
    window.open(url, "_blank");
  }

  getData(endpoint: string): Observable<Response> {
    const request = {
      url: endpoint,
    };
    return this.httpClient.get<Response>(request.url);
  }
}
